import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const PersonalInfo = ({ data, updateData }) => {
  const handleChange = (field, value) => {
    updateData(field, value);
  };

  return (
    <div className="form-section">
      <h2 className="section-title blue">Personal Information</h2>
      
      <div className="form-grid">
        <div className="form-group">
          <label className="form-label">
            Full Name *
          </label>
          <input
            type="text"
            value={data.name}
            onChange={(e) => handleChange('name', e.target.value)}
            className="input-field"
            placeholder="Enter your full name"
            required
          />
        </div>
        
        <div className="form-group">
          <label className="form-label">
            Mobile Number *
          </label>
          <input
            type="tel"
            value={data.mobile}
            onChange={(e) => handleChange('mobile', e.target.value)}
            className="input-field"
            placeholder="Enter your mobile number"
            required
          />
        </div>
        
        <div className="form-group full-width">
          <label className="form-label">
            Email Address *
          </label>
          <input
            type="email"
            value={data.email}
            onChange={(e) => handleChange('email', e.target.value)}
            className="input-field"
            placeholder="Enter your email address"
            required
          />
        </div>
        
        <div className="form-group">
          <label className="form-label">Profile Summary</label>
          <ReactQuill
            value={data.profileSummary}
            onChange={value => updateData('profileSummary', value)}
            className="input-field quill-field"
            placeholder="Write a summary about yourself, your experience, and your goals..."
            theme="snow"
          />
        </div>
        
        <div className="form-group">
          <label className="form-label">LinkedIn</label>
          <input
            type="text"
            value={data.linkedin || ''}
            onChange={e => handleChange('linkedin', e.target.value)}
            className="input-field"
            placeholder="LinkedIn profile URL"
          />
        </div>
        <div className="form-group">
          <label className="form-label">GitHub</label>
          <input
            type="text"
            value={data.github || ''}
            onChange={e => handleChange('github', e.target.value)}
            className="input-field"
            placeholder="GitHub profile URL"
          />
        </div>
      </div>
    </div>
  );
};

export default PersonalInfo; 